// extracted by mini-css-extract-plugin
export default {"info":"BkAyK__NMd2mCRt_nMAe","totpCode":"Po37HHiP7o0iKVyCs2_t","qrCode":"vBnZPZwXxX7vWSWRZQGD"};